<template>
  <BasePermission
    :permission="permission"
    :model-value="isSelected"
    :disabled="disabled"
    :has-extra-content="true"
    @update:model-value="handleSelectionChange"
  >
    <template #extra-content>
      <div class="pt-4 flex flex-col gap-3">
        <PermissionToggleAction
          v-for="action in availableActions"
          :key="action.key"
          :action-name="action.name"
          :model-value="isActionEnabled(action.key)"
          :disabled="disabled"
          @update:model-value="(value) => handleExtraUpdate(action.key, value)"
        />
      </div>
    </template>
  </BasePermission>
</template>

<script setup>
import BasePermission from "./BasePermission.vue";
import PermissionToggleAction from "./PermissionToggleAction.vue";
import { computed } from "vue";
import { POLICY_SCOPES } from "@/src/constants/permissionConstants.js";

const props = defineProps({
  permission: { type: Object, required: true },
  modelValue: { type: Boolean, default: false },
  extraValues: { type: Object, default: () => ({}) },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue", "update:extra"]);

const isSelected = computed(() => props.modelValue);

const toggleActions = new Set(["create", "export", "import"]);

const actionLabels = {
  create: "Create",
  view: "View",
  edit: "Edit",
  delete: "Delete",
  export: "Export",
  import: "Import",
};

const availableActions = computed(() => {
  if (!props.permission.granularActions) return [];
  return props.permission.granularActions
    .filter((a) => a.toLowerCase() !== "enabled")
    .map((a) => ({
      key: a.toLowerCase(),
      name: actionLabels[a.toLowerCase()] || a,
    }));
});

const isActionEnabled = (key) => {
  const val = props.extraValues?.[key];
  if (val === undefined || val === null || val === false) return false;
  if (val === POLICY_SCOPES.NONE) return false;
  return true;
};

const handleSelectionChange = (value) => {
  emit("update:modelValue", value);
};

const handleExtraUpdate = (actionKey, value) => {
  const newVal = toggleActions.has(actionKey)
    ? value
    : value ? POLICY_SCOPES.ALL : POLICY_SCOPES.NONE;
  emit("update:extra", { key: props.permission.key, inputKey: actionKey, value: newVal });
};
</script>
